import { useEffect, useState } from "react";

// Menu contextuel d'un patient, fermé au clic, au défilement ou par Échap.
export default function usePatientContextMenu(setSelectedPatientId) {
    const [menu, setMenu] = useState(null);

    useEffect(() => {
        if (!menu) return undefined;
        const close = () => setMenu(null);
        const closeOnEscape = event => {
            if (event.key === "Escape") close();
        };
        window.addEventListener("mousedown", close);
        window.addEventListener("scroll", close, true);
        window.addEventListener("keydown", closeOnEscape);
        return () => {
            window.removeEventListener("mousedown", close);
            window.removeEventListener("scroll", close, true);
            window.removeEventListener("keydown", closeOnEscape);
        };
    }, [menu]);

    const openMenu = (event, patient) => {
        event.preventDefault();
        setSelectedPatientId(patient.id);
        setMenu({ patient, x: event.clientX, y: event.clientY });
    };

    return { menu, openMenu, closeMenu: () => setMenu(null) };
}
